
<template>
  <div class="ordersAll">
      <div class="main" v-if="detailsType && detailsRedactType">
          <div class="top-search">
              <div class="item"><span>商户名称：</span><div><el-select v-model="orderValue" placeholder="请选择">
                    <el-option
                    v-for="item in orderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select></div>
              </div>
              <div class="item"><span>订单号：</span><div><el-input v-model="orderNo" placeholder="单行输入"></el-input></div></div>
              <div class="item"><span>创建时间：</span>
                <div>
                  <el-date-picker
                    v-model="merchantsTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
              </div>
              <div class="item"><span>业务进度：</span><div>
                  <el-select v-model="statusValue" placeholder="请选择">
                      <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select></div>
              </div>
              <div class="item"><span>分配时间：</span><div>
                <el-date-picker
                  v-model="assignTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </el-date-picker></div>
              </div>
              <div class="item"><span style="width: 50px;"></span><el-button type="primary" @click="merchantsSearch">搜索</el-button> <el-button type="danger" @click="merchantsReset">重置</el-button></div>
          </div>
          <!-- <div class="middle-button"><el-button type="primary" plain>下载列表</el-button></div> -->
          <div class="bottom-table">
              <el-table
                :data="ordertableData"
                border
                height="620"
                style="width: 100%">
                <el-table-column
                prop="id"
                label="订单编号">
                </el-table-column>
                <el-table-column
                prop="deliver.deliverName"
                label="订单交付商">
                </el-table-column>
                <el-table-column
                prop="merchant.name"
                label="商户名称">
                </el-table-column>
                <el-table-column
                prop="legalName"
                label="法人姓名">
                </el-table-column>
                <el-table-column
                prop="idcard"
                label="法人身份证">
                </el-table-column>
                <el-table-column
                prop="price"
                label="订单金额（元）">
                </el-table-column>
                <el-table-column
                prop="created_at"
                label="创建时间">
                </el-table-column>
                <el-table-column
                prop="ostatusName"
                label="业务进度">
                </el-table-column>
                <el-table-column
                prop="statusName"
                label="订单状态">
                </el-table-column>
                <el-table-column
                prop="assignTime"
                label="分配时间">
                </el-table-column>
                <el-table-column
                prop="assignUcname"
                label="分配人">
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <div style="cursor: pointer;">
                      <el-dropdown>
                          <span class="el-dropdown-link">
                              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item><el-button @click="orderDetails(scope.row)" type="primary" size="mini" plain>查看详情</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status == 1000"><el-button @click="orderClosed(scope.row)" type="danger" size="mini" plain>订单关闭</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status == 1020"><el-button @click="newProgress(scope.row,'')" type="danger" size="mini" plain>订单分配</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status == 1130"><el-button @click="newProgress(scope.row,'1')" type="danger" size="mini" plain>交付审核</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status == 1160"><el-button @click="newProgress(scope.row,'2')" type="danger" size="mini" plain>订单完成</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status != 1170"><el-button @click="orderRedact(scope.row)" type="warning" size="mini" plain>&emsp;编辑&emsp;</el-button></el-dropdown-item>
                          </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                </template>
                </el-table-column>
            </el-table>
          </div>
          <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange">
            </el-pagination>
          </div> -->
          <pagination :total="total" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
      </div>
      <!-- 详情 -->
      <div class="main details" v-if="!detailsType">
        <div class="title">
          <div class="fanhui" @click="detailsType = true"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="qianyue">订单详情</div>
        </div>
        <div class="content">
          <div class="name">基本信息</div>
          <div class="box">
            <span>订单号：{{orderListObj.id}}</span><span>创建时间：{{orderListObj.created_at}}</span><span>商户ID：{{orderListObj.merchant_id}}</span><br/>
            <span>商户名称：{{orderListObj.merchant_id}}</span><span>业务状态：{{orderListObj.statusName}}</span><span>订单金额（元）：{{orderListObj.price}}</span><br/>
            <span>订单交付商：{{orderListObj.deliver.deliverName}}</span><span>交付商分成（元）：{{orderListObj.deliver.deliverDivide}}</span><span>分配时间：{{orderListObj.assignTime}}</span>
          </div>
          <div class="name">订单详情</div>
          <div class="box">
            <span>法人姓名：{{orderListObj.legalName}}</span><span>法人身份证号码：{{orderListObj.idcard}}</span><span>法人联系电话：{{orderListObj.legalMobile}}</span><br/>
            <span>法人银行卡号：{{orderListObj.bankNo}}</span><span>注册资本：{{orderListObj.capital}}</span><br/>
            <span>个体工商户名称：{{orderListObj.businessmen.name}}</span><br/>
            <span>经营范围：{{orderListObj.businessType}}</span><br/>
            <span>经营范围详情：{{orderListObj.businessScope}}</span><br/>
            <div class="box_imgs">
              <div class="box-item"><div>身份证正面：</div><div class="box_img" @click="detailsImage(orderListObj.idcardFront)"><img :src="orderListObj.idcardFront" alt=""></div></div>
              <div class="box-item"><div>身份证反面：</div><div class="box_img" @click="detailsImage(orderListObj.idcardBack)"><img :src="orderListObj.idcardBack" alt=""></div></div>
              <div class="box-item"><div>银行卡照片：</div><div class="box_img" @click="detailsImage(orderListObj.bankImg)"><img :src="orderListObj.bankImg" alt=""></div></div>
            </div>
            <span>收件人：张娇</span><br/>
            <span>联系电话：18811051022</span><br/>
            <span>邮寄地址：北京市朝阳区来广营朝来高科技产业园</span>
          </div>
          <div class="name">个体工商户执照信息</div>
          <div class="box">
            <span>个体工商户名称：{{orderListObj.businessmen.name}}</span><span>统一社会信用代码：{{orderListObj.businessmen.creditCode}}</span><span>经营场所：{{orderListObj.businessmen.businessPlace}}</span><br/>
            <span>法人：{{orderListObj.businessmen.legalName}}</span><span>法人身份证号码：{{orderListObj.idcard}}</span><span>注册日期：{{orderListObj.businessmen.regDate}}</span><br/>
            <span>经营范围：{{orderListObj.businessmen.businessScope}}</span><br/>
            <div class="box_imgs">
              <div class="box-item"><div>执照照片：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.businessImg)"><img :src="orderListObj.businessmen.businessImg" alt=""></div></div>
            </div>
          </div>
          <div class="name">个体工商户刻章信息</div>
          <div class="box">
            <div class="box_imgs">
              <div class="box-item"><div>公章：&emsp;</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.gongzhang)"><img :src="orderListObj.businessmen.gongzhang" alt=""></div></div>
              <div class="box-item"><div>发票章：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.fapiaozhang)"><img :src="orderListObj.businessmen.fapiaozhang" alt=""></div></div>
              <div class="box-item"><div>法人章：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.farenzhang)"><img :src="orderListObj.businessmen.farenzhang" alt=""></div></div>
              <div class="box-item"><div>财务章：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.caiwuzhang)"><img :src="orderListObj.businessmen.caiwuzhang" alt=""></div></div>
              <div class="box-item"><div>合同章：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.hetongzhang)"><img :src="orderListObj.businessmen.hetongzhang" alt=""></div></div>
            </div>
          </div>
          <div class="name">个体工商户开户信息</div>
          <div class="box">
            <span>银行开户：{{orderListObj.businessmen.isBank}}</span><span>账户名称：{{orderListObj.businessmen.bankName}}</span><span>账号：{{orderListObj.businessmen.bankNo}}</span><br/>
            <span>开户行：{{orderListObj.businessmen.bank}}</span>
            <div class="box_imgs">
              <div class="box-item"><div>账户图片：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.bankImg)"><img :src="orderListObj.businessmen.bankImg" alt=""></div></div>
            </div>
          </div>
          <div class="name">个体工商户税务报道</div>
          <div class="box">
            <span>税务登记日：{{orderListObj.businessmen.taxRegDay}}</span><span>税务机构名称：{{orderListObj.businessmen.taxOrg}}</span>
            <div class="box_imgs">
              <div class="box-item"><div>CA：&emsp;</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.caImg)"><img :src="orderListObj.businessmen.caImg" alt=""></div></div>
            </div>
          </div>
          <div class="name">订单审核详情</div>
          <div class="box">
            <span>审核状态：审核成功</span><br/>
            <span>审核内容：内容无误，可进行订单交付</span><br/>
            <span>交付内容：除发票章由交付商保留，其余证件全部需要交付</span><br/>
            <span>收件人：吴猛</span><br/>
            <span>联系电话：18202722371</span><br/>
            <span>邮寄地址：北京市朝阳区 XXXXXX</span><br/>
          </div>
          <div class="name">交付商交付信息</div>
          <div class="box">
            <span>快递单号：{{orderListObj.businessmen.courierNo}}</span>
            <div class="box_imgs">
              <div class="box-item"><div>交接单：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.courierImg)"><img :src="orderListObj.businessmen.courierImg" alt=""></div></div>
            </div>
          </div>
          <div class="name">订单交付信息</div>
          <div class="box">
            <span>交付类型：平台交付</span><span>快递单号：{{orderListObj.businessmen.courierNo}}</span>
            <div class="box_imgs">
              <div class="box-item"><div>交接单：</div><div class="box_img" @click="detailsImage(orderListObj.businessmen.courierImg)"><img :src="orderListObj.businessmen.courierImg" alt=""></div></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 编辑 -->
      <div class="main details" v-if="!detailsRedactType">
        <div class="title">
          <div class="fanhui" @click="detailsRedactType = true"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="qianyue">编辑订单</div>
        </div>
        <div class="content">
          <div class="name">订单信息</div>
          <div class="box2">
            <span>订单号：{{orderListObj.id}}</span><span>创建时间：{{orderListObj.created_at}}</span><span>商户ID：{{orderListObj.merchant_id}}</span><br/>
            <span>商户名称：<div style="width: 200px;display: inline-block;">
              <el-select v-model="orderValue" style="width:100%" size="mini" placeholder="请选择">
                    <el-option
                    v-for="item in orderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
              </el-select></div>
            </span>
            <span>订单状态：{{orderListObj.statusName}}</span><span>订单金额（元）：<div style="width: 200px;display: inline-block;"><el-input v-model="orderPrice" size="mini" placeholder="单行输入"></el-input></div></span>
          </div>
          <div><el-button type="primary" @click="modification">修改</el-button><el-button @click="cancel">取消</el-button></div>
        </div>
      </div>
      <!-- 订单分配 -->
      <el-dialog
        title="订单分配"
        :visible.sync="dialogOrder"
        width="575px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="distributionForm" :model="distributionForm" :rules="rulesTwo" label-width="110px">
            <el-form-item label="交付商：" prop="deliverId">
              <div style="width:233px">
                <el-select v-model="distributionForm.deliverId" style="width:100%" placeholder="请选择" @change="distributionChange">
                    <el-option
                    v-for="item in distributionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="交付商分成：" prop="orderDeliver">
              <div style="width:233px">
              <el-input v-model="distributionForm.orderDeliver" type=number ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="distributionSubmit('distributionForm')">确定</el-button>
              <el-button @click="distributionResetForm('distributionForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 交付商交付审核 -->
      <el-dialog
        title="交付商交付审核"
        :visible.sync="dialogOrder0"
        width="673px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="DeliveryAuditForm" :rules="rules" label-width="140px">
            <div>审核信息</div>
            <el-form-item label="审核状态：" prop="status">
              <div style="width:233px">
                <el-select v-model="DeliveryAuditForm.status" style="width:100%" placeholder="请选择">
                  <el-option
                    v-for="item in DeliveryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="审核备注：" prop="auditRemark">
              <div style="width:233px">
                <el-input
                  type="textarea"
                  :rows="3"
                  resize="none"
                  placeholder="多行输入"
                  v-model="DeliveryAuditForm.auditRemark">
                </el-input>
              </div>
            </el-form-item>
            <div>交付商交付相关信息</div>
            <el-form-item label="交付内容：" prop="content">
              <div style="width:233px">
                <el-input
                  type="textarea"
                  :rows="3"
                  resize="none"
                  placeholder="多行输入"
                  v-model="DeliveryAuditForm.content">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="收件人：" prop="addressee">
              <div style="width:233px"><el-input v-model="DeliveryAuditForm.addressee" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="联系电话：" prop="mobile">
              <div style="width:233px"><el-input v-model="DeliveryAuditForm.mobile" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="邮寄地址：" prop="addr">
              <div style="width:233px">
                <el-input
                  type="textarea"
                  :rows="3"
                  resize="none"
                  placeholder="多行输入"
                  v-model="DeliveryAuditForm.addr">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="orderConfirm('orderForm')">确定</el-button>
              <el-button @click="orderResetForm('orderForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 订单完成 -->
      <el-dialog
        title="订单完成"
        :visible.sync="dialogOrder1"
        width="725px"
        :before-close="handleClose">
        <div style="width: 600px; margin: 0 auto; text-align: left;">
          <el-form ref="orderCompleteForm" :model="orderCompleteForm" label-width="90px">
            <el-form-item label="交付类型：">
              <div style="width:233px">
                <el-select v-model="orderCompleteForm.deliverType" style="width:100%" placeholder="请选择">
                    <el-option
                    v-for="item in deliveryTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="快递单号：">
              <div style="width:233px">
              <el-input v-model="orderCompleteForm.deliverNo" placeholder="单行输入"></el-input>
              </div>
            </el-form-item>
            <div style="overflow: hidden;">
              <el-form-item label="交接单：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList)"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderCompleteForm.deliverImg" :src="orderCompleteForm.deliverImg" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
            </div>
            <div style="width: 100%;text-align: center;">
              <el-button type="primary" @click="orderCompleteSubmit('orderCompleteForm')">确定</el-button>
              <el-button @click="orderCompleteReset('orderCompleteForm')">取消</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>
      <!-- 图片查看 -->
      <el-dialog
        title="图片查看"
        :visible.sync="dialogImg"
        width="50%"
        :before-close="handleClose">
        <div>
          <img :src="imageDetails" alt="">
        </div>
      </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
export default {
  data() {
    return {
      imageDetails: '',
      dialogImg: false,
      pageSzie: 10,
      total: null,
      dialogOrder: false,
      dialogOrder0: false,
      dialogOrder1: false,
      detailsType: true,
      detailsRedactType: true,
      orderListObj: {},
      ordertableData: [],
      distributionForm:{
        id: '',             // 商户id
        deliverId: "",      // 交付商id
        deliverName: "",    // 交付商名称
        orderDeliver: '',   // 交付商分成金额
      },
      rulesTwo: {
        orderDeliver: [
          { required: true, message: '请输入交付商分成金额', trigger: 'blur' },
        ],
        deliverId: [
          { required: true, message: '请选择交付商名称', trigger: 'change' }
        ]
      },
      DeliveryOptions:[
        {
          value: '1150',
          label: '审核通过'
        },{
          value: '1140',
          label: '审核不通过'
        }
      ],
      DeliveryAuditForm:{
        id : "",             // 注意 订单办理id，deliver对象中的id，或者order对象中的orderDeliverId
        status : "",                      // 1140审核失败 1150审核成功
        auditRemark : "",                 // 审核备注
        content : "",                   // 交付内容
        addressee : "",                  // 收件人
        mobile : "",              // 联系电话
        addr : "",                   // 联系地址
      },
      DeliveryAuditPrice: null,
      rules: {
        addressee: [
          { required: true, message: '请输入收件人名称', trigger: 'blur' },
          { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '长度11 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ],
        auditRemark: [
          { required: true, message: '请填写审核备注', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请填写交付内容', trigger: 'blur' }
        ],
        addr: [
          { required: true, message: '请填写邮寄地址', trigger: 'blur' }
        ]
      },
      orderForm: {
        orderId: "1",                         // 订单id
        status: "10",                         // 订单状态
        rateOfProgress: '',
        // 执照
        name: '',
        creditCode: '',
        businessPlace: '',
        businessScope: '',
        regDate: '',
        businessImg: '',
        // 刻章办理
        gongzhang: '',            // 公章
        caiwuzhang: '',          // 财务章
        fapiaozhang: '',        // 发票章
        hetongzhang: '',        // 合同章
        farenzhang: '',
        // 银行
        isBank: '',
        bankName: '',
        bankNo: '',
        bank: '',
        bankImg: '',
        // 税务
        caImg: '',
        taxRegDay: '',
        taxOrg: '',
        // 邮寄
        courierNo: '',
        courierImg: ''
      },
      orderOptions: [],
      orderValue: '',
      orderNo:'',
      orderPrice:'',
      distributionOptions: [],
      statusOptions: [
        {value:"1000", label: "未付款"},
        {value:"1010", label: "订单关闭"},
        {value:"1020", label: "待分配"},
        {value:"1030", label: "待处理"},
        {value:"1040", label: "交付商关闭"},
        {value:"1050", label: "执照办理中"},
        {value:"1060", label: "已出执照"},
        {value:"1070", label: "刻章办理中"},
        {value:"1080", label: "已刻章"},
        {value:"1090", label: "银行开户中"},
        {value:"1100", label: "银行卡已开户"},
        {value:"1110", label: "税务报道中"},
        {value:"1120", label: "已税务报道"},
        {value:"1130", label: "提交审核"},
        {value:"1140", label: "审核失败"},
        {value:"1150", label: "审核通过"},
        {value:"1160", label: "已邮寄"},
        {value:"1170", label: "已完成"},
      ],
      deliveryTypeOptions:[
        {
          value: '10',
          label: '交付商交付'
        },{
          value: '20',
          label: '平台交付'
        },{
          value: '30',
          label: '平台保存无需交付'
        }
      ],
      orderCompleteForm:{
        id:"",                // 订单id
        deliverType:"",       // 交付类型
        deliverNo:"",         // 快递单号
        deliverImg:""         // 交接单
      },
      statusValue: '',
      merchantsTime: [],
      assignTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      data: {
        d: {},
        action: ''
      }
    }
  },
  mounted() {
    this.orderOptions = JSON.parse(localStorage.getItem('nameList')) || []
    this.distributionOptions = JSON.parse(localStorage.getItem('deliveryList')) || []
    this.orderListPost()
    this.getUploadConfig()
  },
  methods: {
    detailsImage(src) {
      if (src) {
        this.imageDetails = src
        this.dialogImg = true
      }
    },
    // 订单完成
    orderCompleteSubmit() {
      post(api.orderComplete, this.orderCompleteForm)
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success'
          });
          this.orderListPost()
          this.orderCompleteForm = {
            id:"",                // 订单id
            deliverType:"",       // 交付类型
            deliverNo:"",         // 快递单号
            deliverImg:""         // 交接单
          }
          this.dialogOrder1 = false
        }else {
          this.$message({
            showClose: true,
            message: d.msg,
            type: 'warning'
          });
          console.log(d.msg)
        }
      }, (err) => {
            //error callback
        })
    },
    orderCompleteReset() {
      this.orderCompleteForm = {
        id:"",                // 订单id
        deliverType:"",       // 交付类型
        deliverNo:"",         // 快递单号
        deliverImg:""         // 交接单
      }
      this.dialogOrder1 = false
    },
    // 编辑取消
    cancel() {
      this.orderValue = ''
      this.orderPrice = ''
      this.detailsRedactType = true
    },
    // 修改
    modification() {
      post(api.orderEdit, {
        id: this.orderListObj.id,
        merchantId: this.orderValue,
        price: this.orderPrice
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success'
          });
          this.orderValue = ''
          this.orderPrice = ''
          this.detailsRedactType = true
          this.orderListPost()
        }else {
          this.$message({
            showClose: true,
            message: d.msg,
            type: 'warning'
          });
          console.log(d.msg)
        }
      }, (err) => {
          //error callback
      })
    },
    // 审核确定
    orderConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          post(api.deliverAudit, this.DeliveryAuditForm)
          .then((d) => {
            if (d.status === 0) {
              console.log(d,'!!!!!!!!!!!!')
              this.$message({
                showClose: true,
                message: '提交成功',
                type: 'success'
              });
              this.orderListPost()
              this.$refs[formName].resetFields()
              this.dialogOrder0 = false
            }else {
              this.$message({
                showClose: true,
                message: d.msg,
                type: 'warning'
              });
              console.log(d.msg)
            }
          }, (err) => {
              //error callback
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 审核取消
    orderResetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogOrder0 = false
    },
    getUploadConfig() {
        var that = this;
        post(api.getOssConfig)
        .then((d) => {
          console.log(d,'阿里接口')
          that.data.d["key"] = "zc_wxapplet_" + new Date().getTime() + ".jpg";
          that.data.d["Bucket"] = d.Bucket;
          that.data.d["OSSAccessKeyId"] = d.OSSAccessKeyId;
          that.data.d["signature"] = d.Signature;
          that.data.d["policy"] = d.policy;
          that.data.d["success_action_status"] = d.success_action_status;
          that.data.action = d.url;
        }, (err) => {
            //error callback
        })
    },
    // 重置
    merchantsReset() {
      this.orderValue = ''
      this.orderNo = ''
      this.statusValue = ''
      this.merchantsTime = [
        '',''
      ]
      this.assignTime = [
        '',''
      ]
      this.orderListPost()
    },
    // 搜索
    merchantsSearch() {
      if (this.merchantsTime.length == 0 ) {
        console.log('空的')
        this.merchantsTime = [
          '',''
        ]
      }
      console.log(this.merchantsTime)
      this.orderListPost()
    },
    // 列表
    orderListPost(size) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.orderList, {
        currentPage: size || 1,
        pageSize: this.pageSzie,
        merchantId: this.orderValue,
        orderNo: this.orderNo,
        channelOrderNo: '',
        createdBegin: this.merchantsTime[0],
        createdEnd: this.merchantsTime[1],
        assignBegin: this.assignTime[0],
        assignEnd: this.assignTime[1],
        status: this.statusValue
      })
      .then((d) => {
        console.log(d)
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.total = d.data.count
          loading.close();
          // for (let i = 0; i < d.data.rows.length; i++) {
          //   d.data.rows[i].nameArr = d.data.rows[i].names.split(',')
          // }
          this.ordertableData = d.data.rows
        }else {
          loading.close();
          console.log(d.msg)
          this.ordertableData = []
        }
      }, (err) => {
          loading.close();
          console.log(err.msg)
          //error callback
      })
    },
    handleSizeChange(val) {
      this.pageSzie = val
      console.log(`每页 ${val} 条aaaaa`);
      this.orderListPost()
    },
    handleCurrentChange(size) {
      console.log(size)
      this.orderListPost(size)
    },
    orderDetails(row) {
      console.log(row)
      post(api.orderAllInfo, {
        id: row.id
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.orderListObj = d.data
          this.detailsType = false
        }else {
          console.log(d.msg)
        }
      }, (err) => {
        console.log(err,'出错啦')
          //error callback
      })
      // this.orderListObj = row
    },
    orderRedact (row) {
      console.log(row)
      this.orderListObj = row
      this.detailsRedactType = false
    },
    newProgress(row,val) {
      console.log(row.status);
      this.orderForm.orderId = row.id
      this.orderForm.status = row.nextStatus
      this.orderForm.rateOfProgress = row.nextStatusName
      if (val == '1') {
        this.dialogOrder0 = true
        console.log(row)
        this.DeliveryAuditForm.id = row.orderDeliverId
      }else if (val == '2') {
        this.dialogOrder1 = true
        this.orderCompleteForm.id = row.id
      }else {
        this.dialogOrder = true
        this.DeliveryAuditPrice = row.price
        this.distributionForm.id = row.id
      }
    },
    handleClose(done) {
      done();
    },
    handleAvatarSuccess(res, file, files) {
      // console.log(res, file, files, key)
      var result = res.substring(res.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), res.indexOf('</Location>'));
      this.orderCompleteForm.deliverImg = result
      console.log(result,'上传成功')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      return isJPG;
    },
    // 选择交付商
    distributionChange(val) {
      console.log(val)
      console.log(this.DeliveryAuditPrice)
      var data = this.distributionOptions
      for (let i = 0; i < data.length; i++) {
        if ( val == data[i].value ) {
          this.distributionForm.deliverName = data[i].label
          this.distributionForm.orderDeliver = (this.DeliveryAuditPrice*data[i].divide/100).toFixed(2)
        }
      }
    },
    // 分配
    distributionSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          post(api.orderAssign,this.distributionForm)
          .then((d) => {
              console.log(d,'关闭')
              if (d.status === 0) {
                  this.$message({
                      showClose: true,
                      message: '操作成功',
                      type: 'success'
                  });
                  this.orderListPost()
                  this.$refs[formName].resetFields()
                  this.distributionForm = {
                    id: '',             // 商户id
                    deliverId: "",      // 交付商id
                    deliverName: "",    // 交付商名称
                    orderDeliver: '',   // 交付商分成金额
                  }
                  this.dialogOrder = false
              }
          }, (err) => {
              //error callback
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },
    distributionResetForm(formName) {
      this.distributionForm = {
        id: '',             // 商户id
        deliverId: "",      // 交付商id
        deliverName: "",    // 交付商名称
        orderDeliver: '',   // 交付商分成金额
      }
      this.$refs[formName].resetFields()
      this.dialogOrder = false
    },
    orderClosed(row) {
      this.$confirm('此操作将关闭该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(api.orderClose,{
          "id": row.id
        })
        .then((d) => {
            console.log(d,'关闭')
            if (d.status === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.orderListPost()
            }
        }, (err) => {
            //error callback
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })        
      })
      
    }
  },
  created() {
    
  },
  components: {
    pagination: pagination
  }
}
</script>

<style lang="less" scoped>
.ordersAll {
    width: 100%;
    padding: 22px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .main {
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .top-search {
            width: 100%;
            overflow: hidden;
            .item {
                height: 46px;
                line-height: 46px;
                float: left;
                margin-bottom: 10px;
                span {
                    display: inline-block;
                    width: 81px;
                    font-size:14px;
                    font-family:PingFangSC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    text-align: right;
                    margin-right: 10px;
                }
                div {
                    display: inline-block;
                    width:233px;
                    height:46px;
                }
            }
        }
        .middle-button {
            width: 100%;
            text-align: left;
            padding-top: 10px;
        }
        .bottom-table {
            width: 100%;
            margin-top: 20px;
        }
        .bottom-pag {
            width: 100%;
            margin-top: 20px;
        }
    }
    .details {
      .title {
        width: 100%;
        height: 52px;
        line-height: 52px;
        .fanhui {
          float: left;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(102,102,102,1);
          position: relative;
          cursor: pointer;
        }
        .fanhui:after {
          content: '';
          position: absolute;
          top: 20px;
          right: -16px;
          width: 1px;
          height: 13px;
          background-color: #979797;
        }
        .qianyue {
          float: left;
          margin-left: 24px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:500;
          color:rgba(51,51,51,1);
        }
      }
      .content {
        width: 100%;
        .name {
          width: 100%;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:600;
          color:rgba(51,51,51,1);
          text-align: left;
          padding-left: 10px;
          box-sizing: border-box;
        }
        .box {
          margin-top: 10px;
          width: 100%;
          padding: 30px 65px;
          box-sizing: border-box;
          // background:rgba(250,250,250,1);
          border-radius:6px;
          text-align: left;
          span {
            min-width: 33.33%;
            display: inline-block;
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            // margin: 0px 55px;
            line-height: 36px;
          }
          .box_imgs {
            width: 100%;
            overflow: hidden;
            padding: 8px 0px;
            box-sizing: border-box;
            .box-item {
              min-width: 200px;
              margin-right: 10px;
              font-size: 14px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #333333;
              div {
                margin-right: 10px;
              }
              .box_img {
                width: 200px;
                height: 120px;
                display: inline-block;
                background-color: #eee;
                margin-top: 8px;
                margin-right: 50px;
                cursor: pointer;
                img {
                  display: block;
                  height: 100%;
                  margin: 0 auto;
                }
              }
            }
            div {
              float: left;
            }
            
          } 
        }
        .box2 {
          margin-top: 10px;
          width: 100%;
          padding: 30px 65px;
          box-sizing: border-box;
          border-radius:6px;
          text-align: left;
          overflow: hidden;
          span {
            min-width: 33.33%;
            float: left;
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            // margin: 0px 55px;
            line-height: 36px;
          }
        }
        .box1 {
          margin-top: 10px;
          width: 100%;
          padding: 30px 10px;
          box-sizing: border-box;;
          border-radius:6px;
          text-align: left;
          overflow: hidden;
          .item {
            float: left;
            height:93px;
            margin-right: 100px;
            margin-bottom: 20px;
            div {
              float: left;
              min-width: 55px;
              height: 93px;
            }
            .picture {
              width:167px;
              height:93px;
              background:rgba(246,246,246,1);
              border-radius:8px;
              border:1px solid rgba(198,198,198,1);
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          
        }
      }
    }
}
</style>

<style>
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/trading/order/ordersAll.vue